import { getDB } from '../index.js';
import { getLogger } from '@/utils/logger';

const logger = getLogger('uploadDB');

export async function getUploads(dbName) {
  const db = await getDB(dbName);
  
  const sql = `
    SELECT 
      u.id,
      u.given_name as name,
      u.platform,
      CAST(u.upload_timestamp * 1000 AS INTEGER) as created_at,
      u.updated_at,
      u.color,
      'ready' as status,
      COUNT(e.id) as event_count
    FROM uploads u
    LEFT JOIN events e ON e.upload_id = u.id
    GROUP BY u.id
    ORDER BY u.upload_timestamp DESC
  `;
  
  const rows = await db.exec(sql, {
    returnValue: 'resultRows',
    rowMode: 'object'
  });
  
  return {
    uploads: rows || []
  };
}

export async function getUploadById(dbName, uploadId) {
  if (!uploadId) {
    console.error('[Uploads DB] No uploadId provided');
    return null;
  }
  const db = await getDB(dbName);
  
  const sql = `
    SELECT 
      u.id,
      u.given_name as name,
      u.platform,
      CAST(u.upload_timestamp * 1000 AS INTEGER) as created_at,
      u.updated_at,
      u.color,
      'ready' as status,
      COUNT(e.id) as event_count
    FROM uploads u
    LEFT JOIN events e ON e.upload_id = u.id
    WHERE u.id = ?
    GROUP BY u.id
  `;
  
  const rows = await db.exec(sql, {
    bind: [parseInt(uploadId, 10)],
    returnValue: 'resultRows',
    rowMode: 'object'
  });
  
  return rows.length > 0 ? rows[0] : null;
}

export async function updateUpload(dbName, uploadId, updates) {
  const db = await getDB(dbName);
  
  const allowedFields = ['given_name', 'color'];
  const setClauses = [];
  const values = [];
  
  for (const [key, value] of Object.entries(updates)) {
    if (allowedFields.includes(key)) {
      setClauses.push(`${key} = ?`);
      values.push(value);
    }
  }
  
  if (setClauses.length === 0) {
    logger.debug('updateUpload: No allowed fields found to update');
    return;
  }
  
  // Always update the updated_at timestamp
  setClauses.push('updated_at = ?');
  values.push(Date.now() / 1000);  // Convert to Unix timestamp (seconds)
  
  values.push(uploadId);  // uploadId is already a string UUID, don't parseInt it
  
  const sql = `UPDATE uploads SET ${setClauses.join(', ')} WHERE id = ?`;
  await db.exec(sql, { bind: values });
}

export async function getUploadedFiles(dbName, uploadId) {
  const db = await getDB(dbName);
  const rows = await db.exec(
    `SELECT id, manifest_filename, opfs_filename, file_size_bytes, parse_status, upload_timestamp
     FROM uploaded_files WHERE upload_id = ? ORDER BY upload_timestamp ASC`,
    { bind: [uploadId], returnValue: 'resultRows', rowMode: 'object' }
  );
  return rows || [];
}

export async function deleteUpload(dbName, uploadId) {
  /* Manual cascade: deletes events, uploaded_files, and raw_data rows before removing the upload record itself (schema lacks ON DELETE CASCADE). */
  const db = await getDB(dbName);
  
  await db.exec('DELETE FROM events WHERE upload_id = ?', { 
    bind: [uploadId]
  });
  
  await db.exec('DELETE FROM uploaded_files WHERE upload_id = ?', { 
    bind: [uploadId]
  });
  
  await db.exec('DELETE FROM raw_data WHERE upload_id = ?', { 
    bind: [uploadId]
  });
  
  await db.exec('DELETE FROM uploads WHERE id = ?', { 
    bind: [uploadId]
  });
}
